if (!customElements.get("accordion-wrapper")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.options = this.dataset.options;
      this.onlyOneActive = false;
      
      /* Store bound event handlers for cleanup */
      this.eventHandlers = [];
    }

    connectedCallback() {
      this.items = this.querySelectorAll(".td-accordion__item");
      this.bindEvents();
    }

    disconnectedCallback() {
      /* Remove all stored event listeners */
      this.eventHandlers.forEach(({ element, type, handler }) => {
        element.removeEventListener(type, handler);
      });
      this.eventHandlers = [];
    }

    bindEvents() {
      const el = this;
      this.items.forEach(function (item) {
        const toggle = item.querySelector(".td-accordion__toggle");
        if (toggle) {
          /* Click event handler */
          const clickHandler = function (event) {
            event.preventDefault();
            el.toggle(item.dataset.item);
          };
          toggle.addEventListener("click", clickHandler);
          el.eventHandlers.push({ element: toggle, type: "click", handler: clickHandler });

          /* Keyboard accessibility: Enter and Space keys */
          const keydownHandler = function (event) {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              el.toggle(item.dataset.item);
            }
          };
          toggle.addEventListener("keydown", keydownHandler);
          el.eventHandlers.push({ element: toggle, type: "keydown", handler: keydownHandler });

          /* Open if data-open attribute is set */
          if (item.dataset.open) {
            el.toggle(item.dataset.item);
          }
        }

        const toggleNext = item.querySelector(".td-accordion__toggle-next");
        if (toggleNext) {
          const toggleNextHandler = function (event) {
            event.preventDefault();
            el.toggle(parseInt(item.dataset.item) + 1);
          };
          toggleNext.addEventListener("click", toggleNextHandler);
          el.eventHandlers.push({ element: toggleNext, type: "click", handler: toggleNextHandler });
        }
      });
    }

    toggle(currentItem) {
      const el = this;
      this.items.forEach(function (item) {
        const content = item.querySelector(".td-accordion__content");
        const toggle = item.querySelector(".td-accordion__toggle");
        if (!content) return;

        if (item.dataset.item == currentItem) {
          const isActive = item.classList.contains("is-active");

          if (isActive) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }

          item.classList.toggle("is-active");

          /* Update aria-expanded for accessibility */
          if (toggle) {
            toggle.setAttribute("aria-expanded", !isActive);
          }
        } else if (el.onlyOneActive) {
          item.classList.remove("is-active");
          content.style.maxHeight = null;

          /* Update aria-expanded for accessibility */
          if (toggle) {
            toggle.setAttribute("aria-expanded", "false");
          }
        }
      });
    }
  }

  customElements.define("accordion-wrapper", Accordion);
}
